import { findAll } from "@/services/local/vascular-phenomena-service.js";

const state = {
  flowTypes: [],
  selected: {},
};

const mutations = {
  setFlowTypes(state, value) {
    state.flowTypes = value;
  },
  setSelected(state, value) {
    state.selected = value;
  },
};

const actions = {
  async load({ commit }) {
    const response = await findAll();
    commit("setFlowTypes", response);
  },
  selectOne({ commit, dispatch, rootState }, value) {
    let addedItems = [];

    var isSelected = rootState.diagnosis.diagnose.flowTypes.some(
      (item) => item.flowType.id === value.id
    );

    if (isSelected) {
      addedItems = rootState.diagnosis.diagnose.flowTypes.map(
        (item) => item.resolutionZone.id
      );
    }

    commit("setSelected", value);

    dispatch(
      "resolutionZones/showDialog",
      {
        returnAction: "flowTypes/handleReturnResolutionZone",
        validateAction: "flowTypes/verifyIfAlreadyAdded",
        addedItems,
      },
      { root: true }
    );
  },
  handleReturnResolutionZone(
    { state, commit },
    {
      therapistComments,
      patientComments,
      resolutionZone,
      affectedSpotParTrauma,
      trackingPointSide,
      impactionPointSide,
      parTraumaSide,
      hidePatient,
      patientImpactAtHome,
    }
  ) {
    const diagnose = {
      flowType: state.selected,
      resolutionZone,
      therapistComments,
      patientComments,
      diagnoseResolutionZone: {
        resolutionZone,
        affectedSpotParTrauma,
        trackingPointSide,
        impactionPointSide,
        parTraumaSide,
      },
      hidePatient,
      patientImpactAtHome,
    };

    commit("diagnosis/addFlowType", diagnose, { root: true });
  },
  verifyIfAlreadyAdded({ state, rootState }, { resolutionZone }) {
    return new Promise((resolve, reject) => {
      const exists = rootState.diagnosis.diagnose.flowTypes.some(
        (diagnose) =>
          diagnose.flowType.id === state.selected.id &&
          diagnose.resolutionZone.id === resolutionZone.id
      );
      if (exists) {
        reject({
          message:
            "Combinação de Fenômeno Vascular e Zona de Resolução já adicionado ao diagnóstico.",
        });
      }
      resolve();
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
